<template>
    <van-popup v-model:show="show" position="bottom" :overlay-style="{ overflow: 'hidden' }" :style="{
        minWidth: '100%',
        height: '100%',
        color: '#fff',
    }" class="addAddressPopup">
        <div class="addAddressBook_container">
            <custom-header :text="$t('withdraw.addNewAddress')" :isPopupCloseBackIcon="true" @closePopup="closePopup" />

            <div style="padding: 15px 10px;">
                <div class="crypto_field">
                    <div>{{ $t('withdraw.coin') }}</div>
                    <div class="networkField" style="color: #fff;">{{ coin }}
                    </div>
                </div>
                <div class="crypto_field">
                    <div>{{ $t('withdraw.address') }}</div>
                    <van-field v-model="address" :placeholder="$t('withdraw.address')">
                        <template #right-icon>
                            <div class="right_Icons">
                                <van-icon name="scan" size="22" color="#fff" @click="handleStartScan" />
                            </div>
                        </template>
                    </van-field>
                </div>
                <div class="crypto_field">
                    <div>{{ $t('withdraw.network') }}</div>
                    <div class="networkField" :style="{color: network ? '#fff' : '#c6c1c1'}" @click="showNetworkPopup">{{ network ? network : $t('withdraw.network') }}
                    </div>
                </div>
                <div class="crypto_field">
                    <div>{{ $t('withdraw.walletLabel') }}</div>
                    <van-field v-model="walletLabel" :placeholder="$t('withdraw.walletLabel')"></van-field>
                </div>

                <div class="btn_container">
                    <main-button :title="$t('withdraw.save')" :activeStatus="buttonActive" @click="saveAddress" :radius="'10'" :forceGradientWhenDisabled="true"/>
                </div>
            </div>

        </div>
        <van-popup v-model:show="showScanner" class="transparent-scanner-popup" @closed="stopScanner"
            :overlay-style="{ backgroundColor: 'rgba(0, 0, 0, 0.7)' }">
            <div class="scanner-wrapper">
                <div id="reader"></div>
            </div>
        </van-popup>
        <network-select-popup ref="networkPopupRef" :networkList="networkList" @select-network="setSelectedNetwork" />
        <LoadingScreen ref="loadingRef" />
        <StatusPopup ref="statusRef" :is-show-success="isSuccess" :content="toastContent" />
    </van-popup>
</template>
<script lang="ts" setup>
import CustomHeader from '@/themes/themeThree/components/common/customHeader.vue';
import { addNewNetwork, callNetworkOptions, NetworkChannelItem, useScanner } from '@/view/withdraw/supportScript';
import { computed, onUnmounted, ref, watch } from 'vue';
import NetworkSelectPopup from './networkSelectPopup.vue';
import MainButton from '../../components/common/mainButton.vue';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import StatusPopup from '@/components/common/statusPopup.vue';

const emits = defineEmits(['callNetworkOptions', 'updateAddressbook'])
const address = ref('')
const network = ref('')
const coin = ref('USDT')
const networkList = ref([])
const show = ref(false);
const walletLabel = ref()
const networkPopupRef = ref()
const selectedNetwork = ref()
const isSuccess = ref(false)
const statusRef = ref()
const loadingRef = ref()
const toastContent = ref('')
const buttonActive = computed(() => {
    return (
        address.value !== '' &&
        network.value !== '' &&
        walletLabel.value !== ''
    );
});
const { showScanner, startScanner, stopScanner } = useScanner();
const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}
const openPopup = () => {
    show.value = true;
    getNetworkOption()
}

const closePopup = () => {
    address.value = ''
    network.value = ''
    walletLabel.value = ''
    show.value = false;
}

const handleStartScan = () => {
    startScanner('reader', (result) => {
        address.value = result;
    });
};

const showNetworkPopup = () => {
    networkPopupRef.value.openPopup()
}
const getNetworkOption = async(addr?: string) => {
    if (addr) {
        address.value = addr
    }

    const { network_list } = await callNetworkOptions(address.value)
    networkList.value = network_list

}
const saveAddress = async () => {
    const { data } = await addNewNetwork(address.value, walletLabel.value, selectedNetwork.value?.id)
     if (data.code == 200) {
        loadingRef.value.close()
        showSuccess(data.msg)
        emits('updateAddressbook')
        setTimeout(() => {
           closePopup() 
        },2000)
    } else {
        loadingRef.value.close()
        showError(data)
    }

}
const setSelectedNetwork = (networkData: any) => {
    selectedNetwork.value = networkData
    network.value = networkData?.channelName
    networkPopupRef.value.closePopup()
}
watch(() => address.value, (newVal) => {
    getNetworkOption(newVal)
})
onUnmounted(() => {
    stopScanner();
});
defineExpose({
    openPopup
})
</script>
<style scoped>
.addAddressPopup {
    border-top-left-radius: 20px !important;
    border-top-right-radius: 20px !important;
     border-top-right-radius: 20px !important;
    /* border: 0.5px solid #154084  !important; */
    background: #003231 !important;
    /* box-shadow: inset 0px -3px 0px 0px #014b89, inset 0px 3px 0px 0px #014b89 */
}

.addAddressBook_container {
    padding: 60px 25px;
}

.crypto_field {
    color: #fff;
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 25px;
}

.networkField {
    background: #002121 !important;
    border: 1px solid rgb(0, 97, 95);
    color: #ffffff61 !important;
    padding: 15px 15px !important;
    margin-top: 5px;
    border-radius: 8px;
    align-items: center;
}

.van-cell {
    background: #002121 !important;
    border: 1px solid rgb(0, 97, 95);
    color: #ffffff61 !important;
    padding: 10px 15px !important;
    margin-top: 5px;
    border-radius: 8px;
    align-items: center;
}
.crypto_field :deep(.van-field__control) {
    color: #fff !important;
    font-weight: 700 !important;
    padding: 4px 0px;
}

.crypto_field :deep(.van-field__control::placeholder) {
    color: #ffffff61 !important;
}

.btn_container {
    padding: 30px 0%;
}
.transparent-scanner-popup {
    background: transparent !important;
    overflow: visible;
    width: 80%;
    /* Width of the camera view on screen */
}

.scanner-wrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
}

#reader {
    width: 100%;
    border-radius: 12px;
    overflow: hidden;
    background: #000;
}

:deep(#reader video) {
    width: 100% !important;
    height: auto !important;
    object-fit: cover;
}

:deep(#reader img) {
    display: none !important;
}

:deep(#reader button) {
    display: none !important;
}
</style>